import { render, staticRenderFns } from "./csvideo.vue?vue&type=template&id=c8f6496a&scoped=true&"
import script from "./csvideo.vue?vue&type=script&lang=js&"
export * from "./csvideo.vue?vue&type=script&lang=js&"
import style0 from "./csvideo.vue?vue&type=style&index=0&id=c8f6496a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6496a",
  null
  
)

export default component.exports